/*
 * What was chosen the last time something was spoken into the chat. Kept apart
 * from the practice conversation's devices on purpose: a headset is picked for
 * a roleplay you sit down for, and the laptop microphone is what a one-line
 * chat message gets said into.
 *
 * Storage is not always there — a locked-down browser throws on read as well as
 * on write — and a remembered microphone is a convenience, never a requirement.
 */

const MICROPHONE_KEY = 'chat:microphone';

function read(key: string): string | null {
  try {
    return window.localStorage.getItem(key);
  } catch {
    return null;
  }
}

function write(key: string, value: string): void {
  try {
    window.localStorage.setItem(key, value);
  } catch {
    /* Nothing is remembered; every other visit still works. */
  }
}

export function storedChatMicrophoneId(): string | null {
  return read(MICROPHONE_KEY);
}

export function rememberChatMicrophoneId(deviceId: string): void {
  write(MICROPHONE_KEY, deviceId);
}
